import { render, staticRenderFns } from "./my-volume-library.vue?vue&type=template&id=0db8f68e"
import script from "./my-volume-library.vue?vue&type=script&lang=js"
export * from "./my-volume-library.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports